import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  let token, email, account, doc;

  try {
    token = sessionStorage.getItem("token");
    email = sessionStorage.getItem("emailUser");
    account = sessionStorage.getItem("account");
    doc = sessionStorage.getItem("doc");
  } catch (err) {
    return <Navigate to="/login" />;
  }
  return token && account && email && doc ? (
    <Outlet />
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
